import { SET_CURRENT_USER, LOGOUT_USER } from "../types";

const initialState = {
  authenticated: false,
  user: {}
};

export default function(state = initialState, { type, payload }) {
  switch (type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        authenticated: true,
        user: payload
      };
    case LOGOUT_USER:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
